<div class="nav-header navbar bg-light fixed-top desktop">
    <div class="container header-menu">
        <nav class="navbar navbar-expand-lg navbar-light w-100">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <a class="navbar-brand" routerLink="" >
                <img [src]="logo" width="122" height="42" alt="Logo Toyota" class="logo"/>
            </a>           
            <div class="navbar-collapse nav-header">
                <ul class="col-12 navbar-nav ml-4 mt-2 mt-lg-0 mr-lg-8 ml-lg-8 justify-content-end ff-medium text-uppercase">
                    <li class="nav-link px-3 py-1 item-menu" (click)="abrirSubMenu('motos')">
                        Motos
                        <img class="navbar-icono" [src]="getMenuIcon('motos')"/>
                    </li>
                    <li class="nav-link px-3 py-1 item-menu" (click)="abrirSubMenu('lineafuerza')">
                        Línea de fuerza
                        <img class="navbar-icono" [src]="getMenuIcon('lineafuerza')"/>
                    </li>
                    <li class="nav-link px-3 py-1 item-menu" (click)="abrirSubMenu('servicios')" >
                        Servicios
                        <img class="navbar-icono" [src]="getMenuIcon('servicios')"/>
                    </li>
                    <li class="nav-link px-3 py-1 item-menu" (click)="abrirSubMenu('novedades')" >
                        Novedades
                        <img class="navbar-icono" [src]="getMenuIcon('novedades')"/>
                    </li>
                    <li class="nav-link px-3 py-1" (mouseenter)="abrirSubMenu('sucursales')">
                        <a routerLink="/sucursales">Sucursales</a>
                    </li>
                    <!--<li class="nav-link px-3 py-1" (mouseenter)="abrirSubMenu('sucursales')">
                        <a routerLink="/contacto">Contacto</a>
                    </li>-->
                    <li class="bg-gray" (mouseenter)="abrirSubMenu('user')" *ngIf="!userJson; else userData">
                        <img [src]="imguser" class="float-end d-block my-2 mx-4 iconologin"/>
                    </li>
                    <li class="nav-link">
                        <ng-template #userData>
                            <a class="px-3 py-1 ms-2 rounded-4 text-white item-profile" routerLink="/usuario/perfil"><img [src]="imguserlogin" class="float-end ms-2 my-1 iconuser" width="18"/> Tu Perfil</a>                    
                        </ng-template>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
    <div class="submenu row" *ngIf="isMenuOpen('motos')"  (mouseleave)="cerrarSubMenu('motos')">
        <div class="menu-options">
            <a (click)="cerrarSubMenu('motos')" class="float-end me-4">
                <img src="https://res.cloudinary.com/toyosa-sa/image/upload/v1733520961/production/toyota-bolivia/web/assets/icons/header/icono_cerrar.svg" alt="Cerrar" class="menu-close"/>
            </a>
        </div>
        <div class="submenu-component-actived">
            <app-menu-modelos categoria="motos"></app-menu-modelos>
        </div>
        
    </div>
    <div class="submenu row" *ngIf="isMenuOpen('lineafuerza')"  (mouseleave)="cerrarSubMenu('lineafuerza')">
        <div class="menu-options">
            <a (click)="cerrarSubMenu('lineafuerza')" class="float-end me-4">
                <img src="https://res.cloudinary.com/toyosa-sa/image/upload/v1733520961/production/toyota-bolivia/web/assets/icons/header/icono_cerrar.svg" alt="Cerrar" class="menu-close"/>
            </a>
        </div>
        <div class="submenu-component-actived">
            <app-menu-modelos categoria="linea-de-fuerza"></app-menu-modelos>
        </div>
        
    </div>
    <div class="submenu row" *ngIf="isMenuOpen('servicios')"  (mouseleave)="cerrarSubMenu('servicios')">
        <div class="menu-options">
            <a (click)="cerrarSubMenu('servicios')" class="float-end me-4">
                <img src="https://res.cloudinary.com/toyosa-sa/image/upload/v1733520961/production/toyota-bolivia/web/assets/icons/header/icono_cerrar.svg" alt="Cerrar" class="menu-close"/>
            </a>
        </div>
        <div class="submenu-component-actived">
            <app-menu-servicios></app-menu-servicios>
        </div>
    </div>
    <div class="submenu row" *ngIf="isMenuOpen('novedades')"  (mouseleave)="cerrarSubMenu('novedades')">
        <div class="menu-options">
            <a (click)="cerrarSubMenu('novedades')" class="float-end me-4">
                <img src="https://res.cloudinary.com/toyosa-sa/image/upload/v1733520961/production/toyota-bolivia/web/assets/icons/header/icono_cerrar.svg" alt="Cerrar" class="menu-close"/>
            </a>
        </div>
        <div class="submenu-component-actived">
            <app-menu-novedades></app-menu-novedades>
        </div>
    </div>
    <div class="submenu row" *ngIf="isMenuOpen('user')"  (mouseleave)="cerrarSubMenu('user')">
        <div class="menu-options">
            <a (click)="cerrarSubMenu('user')" class="float-end me-4">
                <img src="https://res.cloudinary.com/toyosa-sa/image/upload/v1733520961/production/toyota-bolivia/web/assets/icons/header/icono_cerrar.svg" alt="Cerrar" class="menu-close"/>
            </a>
        </div>
        <div class="submenu-component-actived">
            <app-menu-usuario></app-menu-usuario>
        </div>
    </div>
</div>
<app-nav-mobile class="mobile"></app-nav-mobile>
